import { useLayoutEffect, useState } from 'react';
import type React from 'react';

export type Orientace = 'vyska' | 'sirka';

/** Výška větší než šířka = na výšku. Čtverec a nezměřené rozměry = na šířku. */
export const orientaceZRozmeru = (sirka: number, vyska: number): Orientace => (vyska > sirka ? 'vyska' : 'sirka');

/**
 * Orientace kiosku podle poměru stran KONTEJNERU (ResizeObserver). Výchozí hodnota je synchronně
 * z okna, takže se rozložení po prvním měření nepřepne a Leaflet se neinicializuje dvakrát.
 * Vynucená orientace (URL ?orientace=, čte DashboardPage) má přednost.
 */
export const useOrientaceKontejneru = (ref: React.RefObject<HTMLElement | null>, vynucena?: Orientace): Orientace => {
    const [zmerena, setZmerena] = useState<Orientace>(() =>
        typeof window === 'undefined' ? 'sirka' : orientaceZRozmeru(window.innerWidth, window.innerHeight));

    useLayoutEffect(() => {
        if (vynucena) return undefined;
        const el = ref.current;
        if (!el) return undefined;
        const zmer = () => {
            const w = el.clientWidth;
            const h = el.clientHeight;
            if (w > 0 && h > 0) setZmerena(orientaceZRozmeru(w, h));
        };
        zmer();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const ro = new ResizeObserver(zmer);
        ro.observe(el);
        return () => ro.disconnect();
    }, [ref, vynucena]);

    return vynucena ?? zmerena;
};
